import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export default (mailboxInfo?: MailboxInfo): 0 | 1 => {
    return getStore(mailboxInfo).settings.ReliabilityCheck.isPresent === true ? 1 : 0;
};
